import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../../services/translation';

export default class SortingSelector extends Component {

    static propTypes = {
        sortBy: PropTypes.string,
        sortDirection: PropTypes.string,
        handleSortingChange: PropTypes.func,
        defaultSortingValue: PropTypes.string,
        priceSortingValue: PropTypes.string,
        durationSortingValue: PropTypes.string
    };

    toggleSortDirection = () => {
        const newDirection = this.props.sortDirection === 'asc' ? 'desc' : 'asc';
        this.props.handleSortingChange('sortDirection', newDirection)
    };

    render() {
        const {sortBy, sortDirection, handleSortingChange, defaultSortingValue, priceSortingValue, durationSortingValue} = this.props;

        return (
            <div className={'plannerSortingElement'}>
                <div className={'selectCustom'}>
                    <select value={sortBy} name="selectedSortBy" onChange={(event) => handleSortingChange('sortBy', event.target.value)}>
                        <option value={defaultSortingValue}>{translate('planner_list.sorting.default')}</option>
                        <option value={priceSortingValue}>{translate('planner_list.sorting.price')}</option>
                        {durationSortingValue &&
                            <option value={durationSortingValue}>{translate('planner_list.sorting.duration')}</option>
                        }
                    </select>
                </div>


                <div className={'directionSortBy'}>
                    <span className={'linkDirectionIndicator ' + sortDirection} onClick={this.toggleSortDirection}>
                        <span className={'sortIcon sortIconDesc'}/>
                        <span className={'sortIcon sortIconAsc'}/>
                    </span>
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Planner/SortingSelector.js